import { isAxiosError } from "@helpers/lib/axios";

const isNetworkError = (error: unknown): boolean =>
	isAxiosError(error) &&
	(error.code === "ERR_NETWORK" || error.code === "ERR_CANCELED");

export const shouldRetryAnswerEvent = (
	failureCount: number,
	error: unknown,
): boolean => {
	if (isNetworkError(error)) {
		return failureCount < 7;
	}
	return failureCount < 3;
};

export const getAnswerEventRetryDelay = (
	attempt: number,
	error: unknown,
): number => {
	if (isNetworkError(error)) {
		return Math.min(2000 * 2 ** attempt, 60000);
	}
	return Math.min(1000 * 2 ** attempt, 30000);
};
